import styled from 'styled-components';

export const BoxSendEmail = styled.div`
  width: 750px;  
  height: 550px;
  padding: 10px;
  outline: none;
  background: #fff;
  box-shadow: 0px 0px 10px; 
  border: 2px solid #26B2D1;
  border-radius: 10px;
`

// export const StatusContainer = styled.div`
//   width: 100%;
//   text-align: center;  
// `
